<template>
  <div class="menu">
    <div :class="`${type} menu-trigger full`" @click="show = true"></div>
    <van-popup get-container="body" v-model="show" position="top">
      <van-cell
        v-for="item in menu"
        :key="item.name"
        :title="item.text"
        :class="`rfs14 ${item.isActive ? 'color-primary' : ''}`"
        @click="go(item)"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    // light、dark
    type: { type: String, default: 'light' },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    menu() {
      const { name } = this.$route;
      return [
        { text: '首页', name: 'home', isActive: name === 'home' },
        { text: '平台优势', name: 'advantage', isActive: name === 'advantage' },
        { text: '产品介绍', name: 'introduction', isActive: name === 'introduction' },
        { text: '本地化广告', name: 'localization', isActive: name === 'localization' },
        { text: '案例洞察', name: 'caseinsight', isActive: name === 'caseinsight' },
        { text: '广告投放', name: 'advertising', isActive: name === 'advertising' },
        { text: '联系我们', name: 'contact', isActive: name === 'contact' },
      ];
    },
  },
  watch: {},
  methods: {
    go(item) {
      if (!item.isActive) {
        this.$router.push({ name: item.name });
      }
      this.show = false;
    },
    onOpen() {},
  },
  created() {},
  mounted() {},
};
</script>
<style lang='scss' scoped>
.menu {
  width: 0.23rem;
  height: 0.12rem;
}
.menu-trigger {
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  &.light {
    background-image: url('https://static.wkanx.com/w002/M00/05/EA/CgIXlV6ZRDmAP4-zAAAA0pdR-VI395.png');
  }
  &.dark {
    background-image: url('https://static.wkanx.com/w002/M00/05/F0/CgIXlV6dF5mAH3DeAAAA0rZ46Kw619.png');
  }
}
.van-popup {
  border-radius: 0 0 20px 20px;
  .van-cell {
    &::after {
      left: 20px;
      right: 20px;
    }
    color: #565656;
  }
  .van-cell__title {
    text-align: center;
  }
}
</style>
